// Weight uses Spending's shared class strings (44px targets, 3px focus ring, 24px cards);
// AppShell already gives the 16px side gutter and the room above the bottom nav.
export { ACCENT_LINK, CARD, FOCUS, H1, LABEL, QUIET_LINK, SCREEN } from '../spending/styles';

/** The big number (design.md: DM Mono for numbers). */
export const HERO_NUM = 'font-mono tabular-nums text-[44px] leading-none text-fg';
